import { Component, OnInit, ViewChild, ChangeDetectorRef, ChangeDetectionStrategy, OnDestroy, AfterViewInit } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';

import { SubSink } from 'subsink';

import { SubjectsService } from '../../../core/services/subjects.service';

import { ListadoModalBalanceOtrosProductosDto } from './../../../feature/monitoreo/data/ListadoModalBalanceOtrosProductosDto';

@Component({
  selector: 'app-tabla-balance-otros-productos-empresas',
  templateUrl: './tabla-balance-otros-productos-empresas.component.html',
  styleUrls: ['./tabla-balance-otros-productos-empresas.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TablaBalanceOtrosProductosEmpresasComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  public subs = new SubSink();

  public listadoModalBalanceOtrosProductosDto: ListadoModalBalanceOtrosProductosDto[] = [];
  public displayedColumns: string[] = [
    'empresa',
    'grupo',
    'responsable',
    'contacto',
    'recarga',
    'factura'
  ];
  public columns: string[];
  public dataSource: MatTableDataSource<ListadoModalBalanceOtrosProductosDto>;

  constructor(
    private readonly subjectServices: SubjectsService,
    private cdr: ChangeDetectorRef,
    public dialog: MatDialog) { }

  ngOnInit(): void {
    this.paginationDataTable();
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  public paginationDataTable(): void {
    this.subs.add(this.subjectServices.informacionModalBalanceOtrosProductosGet.subscribe({
      next: (data) => {
        this.listadoModalBalanceOtrosProductosDto = data.data;
        this.dataSource = new MatTableDataSource(this.listadoModalBalanceOtrosProductosDto);
        this.cdr.markForCheck();
      }
    }));
  }

  public applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    this.firstPage();
  }

  public firstPage(): void {
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
